/**
 * Namespace `appLinks` — PLAT-2026-134 · ADR-014 bt D10: link App Link PHÍA bube-banktransfer (bube-shop ↔ bt). bt dựng tenant
 * « phản chiếu » không có thành viên bt nên dashboard bt không có màn này; nhân viên Bube xử lý tay ở đây khi có sự cố. Bản gốc
 * tiếng Việt. Mã cố định (`delivery_dead_letter`, `APP_LINK_*`…) do máy chủ trả; chữ hiển thị ở đây.
 */
export const appLinks = {
  title: "Liên kết ứng dụng",
  intro:
    "Link App Link giữa bube-shop và bube-banktransfer, nhìn từ phía bt. Khách không có màn này ở dashboard bt — nhân viên xử lý tay khi có sự cố. Mỗi bên chỉ đổi được ý định (intent) CỦA MÌNH: ở đây bạn chỉ đổi ý định của bt, ý định của bube-shop chỉ để xem.",
  refresh: "Tải lại",
  loading: "Đang đọc link…",
  loadFailed: "Không đọc được link App Link của bube-banktransfer.",
  empty: "Chưa có link App Link nào ở bube-banktransfer.",
  truncated: "Chỉ hiện {limit} link tạo gần nhất.",
  writeOnly: "Cần quyền ghi bube-banktransfer để tạm dừng, ngắt hoặc gửi lại.",
  unknownCompany: "(không đọc được tên công ty)",
  "field.company": "Công ty (tenant bt)",
  "field.peer": "Bên kia",
  "field.lifecycle": "Trạng thái hiệu lực",
  "field.localIntent": "Ý định của bt",
  "field.peerIntent": "Ý định của {peer}",
  "field.peerIntentNone": "chưa nhận khẳng định nào",
  "field.branches": "Chi nhánh đã bind",
  "field.health": "Sức khoẻ",
  "field.deliveries": "Lượt giao",
  "field.lastError": "Lỗi cuối",
  "field.probe": "Kiểm tra bên kia lần cuối OK",
  "field.noError": "không có",
  "field.never": "chưa lần nào",
  "intent.revision": "bản {n} · {at}",
  "lifecycle.pending": "Đang dựng",
  "lifecycle.active": "Hoạt động",
  "lifecycle.suspended": "Tạm dừng",
  "lifecycle.disconnected": "Đã ngắt",
  "intent.active": "Bật",
  "intent.suspended": "Tạm dừng",
  "intent.disconnected": "Ngắt",
  "health.unknown": "Chưa rõ",
  "health.healthy": "Khoẻ",
  "health.degraded": "Suy giảm",
  "health.error": "Lỗi",
  "reason.never_synced": "Chưa đồng bộ lần nào.",
  "reason.capabilities_unknown": "Chưa biết bên kia hỗ trợ loại sự kiện nào — chờ kiểm tra khả năng.",
  "reason.intent_unconverged": "Có thay đổi ý định đang chờ giao cho bên kia.",
  "reason.delivery_lagging": "Có lượt giao nghiệp vụ chờ quá 15 phút.",
  "reason.delivery_unsupported": "Bên kia chưa nhận loại sự kiện của một số lượt giao.",
  "reason.delivery_dead_letter": "Có lượt giao quá hạn thử lại, không tự giao nữa — cần « Gửi lại ».",
  "reason.delivery_failing": "Giao liên tiếp thất bại nhiều lần.",
  "reason.sync_failing": "Đồng bộ cấu trúc liên tiếp thất bại.",
  "reason.sync_behind": "Cấu trúc chưa theo kịp bên kia.",
  "reason.branches_unbound": "Có chi nhánh bên kia đã đẩy sang mà bt chưa bind.",
  "reason.apply_failed": "bt từ chối bản cấu trúc mới nhất của bên kia.",
  "deliveries.pending": "Chờ giao {n}",
  "deliveries.held": "Đang giữ {n}",
  "deliveries.unsupported": "Chưa được nhận {n}",
  "deliveries.deadLetter": "Quá hạn {n}",
  "deliveries.none": "không có lượt tồn",
  "deliveries.hint":
    "Giữ = link chưa mở nên chưa gửi (tự thả khi mở lại) · Chưa được nhận = bên kia chưa khai nhận loại sự kiện đó · Quá hạn = đã thử lại hết, chỉ « Gửi lại » mới đưa về hàng đợi.",
  "action.suspend": "Tạm dừng",
  "action.resume": "Tiếp tục",
  "action.disconnect": "Ngắt kết nối",
  "action.reconnect": "Kết nối lại",
  "action.redrive": "Gửi lại {n} lượt quá hạn",
  "confirm.cancel": "Huỷ",
  "confirm.busy": "Đang gửi…",
  "confirm.failed": "Không thực hiện được.",
  "confirm.title.suspend": "Tạm dừng link với {peer}?",
  "confirm.title.resume": "Tiếp tục link với {peer}?",
  "confirm.title.disconnect": "Ngắt kết nối link với {peer}?",
  "confirm.title.reconnect": "Kết nối lại link với {peer}?",
  "confirm.title.redrive": "Gửi lại {n} lượt quá hạn?",
  "confirm.scope": "Công ty {company} · link {link}. Chỉ đổi ý định CỦA bt; ý định của {peer} giữ nguyên.",
  "confirm.effect.suspend.1": "Link ngừng chạy nghiệp vụ: bt không gửi tiền về {peer}, lượt giao nghiệp vụ được GIỮ LẠI (không mất).",
  "confirm.effect.suspend.2": "{peer} nhận thông báo đổi ý định và thấy link tạm dừng.",
  "confirm.effect.suspend.3": "Hoàn tác được bằng « Tiếp tục » bất kỳ lúc nào.",
  "confirm.effect.resume.1": "Link chỉ chạy lại khi CẢ HAI bên đều bật — nếu {peer} vẫn tạm dừng / ngắt thì link vẫn không chạy.",
  "confirm.effect.resume.2": "bt kiểm lại khả năng của bên kia rồi mới thả các lượt đang giữ.",
  "confirm.effect.disconnect.1": "Link bị ngắt: lượt giao nghiệp vụ đang chờ sẽ bị BỎ khi nhịp giao gặp chúng (không gửi về {peer}).",
  "confirm.effect.disconnect.2": "{peer} nhận thông báo đổi ý định và thấy link bị ngắt.",
  "confirm.effect.disconnect.3": "Nối lại được bằng « Kết nối lại », nhưng lượt đã bỏ không quay lại.",
  "confirm.effect.reconnect.1": "Link chỉ chạy lại khi CẢ HAI bên đều bật — nếu {peer} vẫn tạm dừng / ngắt thì link vẫn không chạy.",
  "confirm.effect.reconnect.2": "bt kiểm lại khả năng của bên kia rồi mới thả các lượt đang giữ.",
  "confirm.effect.redrive.1": "{n} lượt quá hạn quay lại hàng đợi, đếm lại số lần thử từ 0 và được giao ngay ở nhịp tới.",
  "confirm.effect.redrive.2": "Lượt vẫn đi qua luật của link: link đang tạm dừng / ngắt thì lượt bị giữ hoặc bỏ, không vượt rào.",
  "confirm.type": "Gõ lại tên công ty (hoặc mã link nếu không có tên) để xác nhận:",
  "confirm.submit": "Xác nhận",
  "result.changed": "Đã đổi ý định của bt thành « {intent} ». Hiệu lực mới của link: {lifecycle}.",
  "result.unchanged": "Ý định của bt đã ở trạng thái đó — không đổi gì.",
  "result.redriven": "Đã xếp lại {n} lượt vào hàng đợi.",
  "result.redrivenNone": "Không còn lượt quá hạn nào để gửi lại.",
} as const;
